import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { getAuditEvents } from "@/lib/api";
import { formatDate } from "@/lib/format";

const ACCION_LABEL = {
  "game.create": "Juego creado",
  "game.update": "Juego actualizado",
  "game.deactivate": "Juego desactivado",
  "draw.commit": "Compromiso publicado",
  "draw.run": "Sorteo ejecutado",
  "draw.reveal": "Semilla revelada",
};

export default function Audit() {
  const [events, setEvents] = useState([]);
  useEffect(() => { getAuditEvents({ limit: 300 }).then(setEvents).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Auditoría</h1>
      <p className="text-sm text-muted-foreground">Historial de acciones del sistema (quién, qué, cuándo).</p>
      <Card className="mt-6">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader><TableRow>
                <TableHead>Acción</TableHead><TableHead>Actor</TableHead><TableHead>Detalle</TableHead><TableHead>Fecha</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {events.length === 0 ? (
                  <TableRow><TableCell colSpan={4} className="py-10 text-center text-muted-foreground">Sin eventos aún.</TableCell></TableRow>
                ) : events.map((e) => (
                  <TableRow key={e.id} data-testid={`audit-row-${e.id}`}>
                    <TableCell><Badge variant="outline">{ACCION_LABEL[e.accion] || e.accion}</Badge></TableCell>
                    <TableCell className="text-sm">{e.actor}</TableCell>
                    <TableCell className="max-w-[360px] truncate font-mono text-xs text-muted-foreground">{JSON.stringify(e.detalle)}</TableCell>
                    <TableCell className="whitespace-nowrap text-xs text-muted-foreground">{formatDate(e.timestamp)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
